import {
	useBlockProps,
	useInnerBlocksProps,
	InspectorControls,
} from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	__experimentalUnitControl as UnitControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import '../style.scss';

const PLACEHOLDER_IMAGES = [
	'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=800&fit=crop',
	'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1200&h=800&fit=crop',
	'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&h=800&fit=crop',
];

const DEFAULT_TEMPLATE = PLACEHOLDER_IMAGES.map( ( url, i ) => [
	'brandy/sticky-section',
	{},
	[
		[
			'core/cover',
			{
				url,
				dimRatio: 40,
				minHeight: 100,
				minHeightUnit: 'vh',
				contentPosition: 'center center',
			},
			[
				[
					'core/heading',
					{
						level: 2,
						content: `Section ${ i + 1 }`,
						textAlign: 'center',
						style: { color: { text: '#ffffff' } },
					},
				],
			],
		],
	],
] );

export default function Edit( { attributes, setAttributes } ) {
	const blockProps = useBlockProps( {
		className: 'brandy-sticky-sections',
	} );

	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		template: DEFAULT_TEMPLATE,
		renderAppender: false,
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody
					title={ __( 'Settings', 'brandy-blocks' ) }
				>
					<SelectControl
						__nextHasNoMarginBottom
						label={ __(
							'Scroll type',
							'brandy-blocks'
						) }
						value={ attributes.type ?? 'stacked' }
						options={ [
							{
								label: __(
									'Stacked',
									'brandy-blocks'
								),
								value: 'stacked',
							},
							{
								label: __(
									'Horizontal',
									'brandy-blocks'
								),
								value: 'horizontal',
							},
						] }
						onChange={ ( v ) =>
							setAttributes( { type: v } )
						}
						help={
							attributes.type === 'horizontal'
								? __(
										'Horizontal scroll is visible on the front end only.',
										'brandy-blocks'
								  )
								: undefined
						}
					/>
					<SelectControl
						__nextHasNoMarginBottom
						label={ __(
							'Cover effect',
							'brandy-blocks'
						) }
						value={
							attributes.coverEffect ?? 'scale-fade'
						}
						options={ [
							{
								label: __(
									'Scale + Fade',
									'brandy-blocks'
								),
								value: 'scale-fade',
							},
							{
								label: __(
									'Scale',
									'brandy-blocks'
								),
								value: 'scale',
							},
							{
								label: __(
									'Fade',
									'brandy-blocks'
								),
								value: 'fade',
							},
							{
								label: __(
									'None',
									'brandy-blocks'
								),
								value: 'none',
							},
						] }
						onChange={ ( v ) =>
							setAttributes( { coverEffect: v } )
						}
					/>
					<UnitControl
						label={ __(
							'Section height',
							'brandy-blocks'
						) }
						value={
							attributes.sectionHeight ?? '100vh'
						}
						onChange={ ( v ) =>
							setAttributes( { sectionHeight: v } )
						}
					/>
				</PanelBody>
			</InspectorControls>
			<div { ...innerBlocksProps } />
		</>
	);
}
